export  enum UserRoles
{
  SuperAdmin = 1,
  Admin = 2,
  Auditor = 3,
  Counter = 4,
}
